import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button, Grid, Form, Segment, Divider } from 'semantic-ui-react';

import * as AppActions from '../../actions';
import LoginLinks from './LoginLinks';

class ForgotPassword extends Component {
  state = {
    username: '',
    message: ''
  };

  forgotPassword = async (event) => {
    event.preventDefault();
    const { actions, user } = this.props;
    const { username } = this.state;
    if (user.loading) return;

    if (!this.state.username) {
      this.setState({ message: 'The Username is required' });
      return;
    }

    try {
      await actions.forgotPassword({ username });
      this.setState({
        message:
          'Success. Please check the Email or SMS attached to this account for next steps.'
      });
    } catch (error) {
      console.log(error);
      this.setState({ message: error.message });
    }
  };

  goToResetPassword = () => {
    this.props.handleSwitchForm('resetPassword');
  };

  passwordForm = () => (
    <div className="container">
      <div className="">
        <Grid>
          <Grid.Column>
            <Segment className="rounded-container">
              <Form className="Login-form" onSubmit={this.forgotPassword}>
                <Form.Field>
                  <input
                    placeholder="Username"
                    id="username"
                    className="format-login-input"
                    onChange={(event) =>
                      this.setState({ username: event.target.value })
                    }
                    type="text"
                  />
                </Form.Field>
                <Divider hidden />
                <div className="forgot-password-buttons">
                  <div className="forgot-password-button-container">
                    <Button
                      type="submit"
                      color="black"
                      className="forgot-button"
                      fluid
                    >
                      Forgot Password
                    </Button>
                  </div>
                  <div className="forgot-password-button-container">
                    <Button
                      type="button"
                      onClick={this.goToResetPassword}
                      color="black"
                      className="forgot-button"
                      fluid
                    >
                      Reset Password
                    </Button>
                  </div>
                </div>
              </Form>
              <Divider hidden />
              <LoginLinks handleSwitchForm={this.props.handleSwitchForm} />
              <div className="login-error">{this.state.message}</div>
            </Segment>
          </Grid.Column>
        </Grid>
      </div>
    </div>
  );

  render() {
    return this.passwordForm();
  }
}

const mapStateToProps = (state) => ({
  user: state.user
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(AppActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);



// WEBPACK FOOTER //
// ./src/screens/Auth/ForgotPassword.js